import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { DataChannelClientAppVersionMessage } from '../../video-sdk';
import { inSessionPatientInformationAtom } from '../state';

export function useHandleClientAppVersionCallback() {
  const setInSessionPatientInformation = useSetAtom(inSessionPatientInformationAtom);

  return useCallback(
    (message: DataChannelClientAppVersionMessage) => {
      const patientShortId = message.sender.entityId;
      // Emits when visitor is already in session
      setInSessionPatientInformation((prev) => {
        if (!prev || prev.patientShortId !== patientShortId) return prev;

        return {
          ...prev,
          appVersion: message.appVersion,
        };
      });
    },
    [setInSessionPatientInformation],
  );
}
